import localimgpath from "../../js/localimgpath";
import TalnetbgImageData from "../../js/talnetbgImageData";
import { IoIosArrowRoundBack } from "react-icons/io";
import malePlaceholder from "../../assets/image/male.png";
import femalePlaceholder from "../../assets/image/female.png";
// import bannerPlaceholder from "../../assets/image/gem_bann_web_3x.png";
import {
  Animatespin,
  MainHeading,
  Footer,
  Navbar,
  Experience,
  HoverButton,
  CheckBoxSelection,
  CategoriesBtnCom,
  Dropdown,
  Talentcard,
  Button,
  Text,
} from "../../components/index";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import Functions from "./index,function";
import { fontSizes } from "../../constants/constants";

const getPlaceholderImage = (genderId) => {
  if (genderId === 1 || genderId === "1") {
    return femalePlaceholder;
  } else if (genderId === 2 || genderId === "2") {
    return malePlaceholder;
  } else {
    return malePlaceholder;
  }
};

const Talent = () => {
  const {
    // states
    filterPopup,
    setFilterPopup,
    rangeAge,
    setRangeAge,
    rangeHeight,
    setRangeHeight,
    rangeWeight,
    setRangeWeight,

    // refs
    sliderRefAge,
    sliderRefHeight,
    sliderRefWeight,

    // tooltips
    tooltipPosAge,
    tooltipPosHeight,
    tooltipPosWeight,

    // handlers
    handleTalent,
    handleDropdwonSelect,
    handleInputAge,
    handleInputHeight,
    handleInputWeight,
    resetFilters,
    onSubmit,

    // data
    talentData,
    dropdowns,
    states,
    cities,
    dropdownLoading,
    isLoading,
    isLoadingStates,
    citiesisLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,

    // forms
    errors,
    register,
    control,
    handleSubmit,
    RadioValueandLable,

    // UI
    Icons,
    select,
    TextWeight,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Talent List"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
          navigate={"/"}
        />

        <div className="py-4">
          <CategoriesBtnCom
            onClick={() => {
              setFilterPopup(true);
            }}
            btnTitle={"Filter"}
            bgColor={"#2A2A2A"}
            btnIcon={Icons.joblistingFiltersIcons}
            CateclassName={
              "cursor-pointer xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64"
            }
            fontClassname={"font-onestSemiBold"}
            iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
            alt={"Filter"}
          />
        </div>
        {!isLoading &&
        talentData?.pages?.every((p) => p?.talent?.length === 0) ? (
          <div className="w-full text-center text-secondary">
            data not found
          </div>
        ) : (
          <>
            <div className="flex flex-wrap xs:gap-2 sm:gap-2 lg:gap-x-2 xl:gap-7 2xl:gap-7 justify-center items-center">
              {talentData?.pages?.map((page, pageIndex) =>
                page?.talent?.map((value, index) => (
                  <div key={index}>
                    <Talentcard
                      onClick={() => handleTalent(value?.id)}
                      image={
                        value?.hero_image
                          ? `${localimgpath?.talentThumbnail}/${value?.hero_image}`
                          : getPlaceholderImage(value?.gender_id)
                      }
                      backgroundImage={
                        TalnetbgImageData[index % TalnetbgImageData.length]
                          .backgroundImage
                      }
                      title={
                        <>
                          {value?.real_name.split(" ")[0]} <br />{" "}
                          {value?.real_name.split(" ")[1]}
                        </>
                      }
                      realName={value?.real_name}
                      desiredJobTypes={value?.desired_job_types?.slice(0, 2)} 
                      backgroundImageClass={`xs:w-[9rem] sm:w-44 xl:w-[18rem] lg:w-[14rem] 2xl:w-[22rem]`}
                      Talentcardlayout={
                        "xs:w-[9rem] xs:h-[12rem] sm:w-44 sm:h-60 xl:w-[18rem] xl:h-[27rem] lg:w-[14rem] lg:h-[19rem] xl:h-[24rem] 2xl:w-[22rem] 2xl:h-[29.4rem]"
                      }
                    />
                  </div>
                ))
              )}
            </div>
          </>
        )}
        {isFetchingNextPage || isLoading ? (
          <div className="pt-4">
            <Animatespin />
          </div>
        ) : (
          hasNextPage && (
            <div className="flex justify-center items-center pt-20">
              <HoverButton
                onClick={() => fetchNextPage()}
                extraClasses="group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                BtnTitle="Load More Talent"
                BtnTitleClasses="text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
              />
            </div>
          )
        )}
      </div>
      <div className="xs:pt-4">
        <Experience />
      </div>
      <Footer />
      <div
        className={`fixed top-0 right-0 z-50 w-full sm:w-9/12 lg:w-7/12 xl:w-1/3 bg-[#0F0F0F] xs:py-3 sm:py-4 xs:px-4 sm:px-3 lg:px-4 lg:py-5 h-screen transition-transform duration-300 ease-in-out ${
          filterPopup ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <form
          className="flex flex-col h-full w-full"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* Header */}
          <div className="w-full">
            <div
              className={`group flex cursor-pointer justify-center items-center xs:px-1.5 sm:px-3 w-fit lg:px-5 xs:py-[1.5px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
              onClick={() => setFilterPopup(false)}
            >
              <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
              <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
                Back
              </p>
            </div>
            <div className="text-center w-full xs:pt-4 xs:pb-5 sm:pt-7 sm:pb-7 lg:pb-10">
              <h2 className="text-secondary font-unboundedBold uppercase xs:text-xs sm:text-lg lg:text-xl xl:text-4xl">
                Talent Filter
              </h2>
            </div>
          </div>

          {/* Scrollable Form Section */}
          <div className="flex-1 overflow-y-auto dashboard-scrollbar overflow-x-visible sm:pr-2 pr-1">
            <div className="flex flex-col justify-start items-center w-full gap-4">
              <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4 "}>
                <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                  <Dropdown
                    control={control}
                    label={"Country"}
                    options={dropdowns?.country}
                    valueName="country"
                    valueoption="country_id"
                    name={"countries"}
                    rightIcon={Icons.arrowIcon}
                    selectedValue={select.country}
                    handleSelect={(value) =>
                      handleDropdwonSelect("country", value)
                    }
                    errors={errors}
                    isRequired={true}
                    isLoading={isLoading}
                  />
                </div>
                <div className="relative xs:w-full sm:w-1/2 lg:w-1/2 xs:mt-[18px]">
                  <Dropdown
                    control={control}
                    label={"Province / State"}
                    options={states}
                    name={"states"}
                    valueName="state"
                    valueoption="state_id"
                    rightIcon={Icons.arrowIcon}
                    selectedValue={select.states}
                    handleSelect={(value) =>
                      handleDropdwonSelect("states", value)
                    }
                    errors={errors}
                    isRequired={true}
                    isLoading={isLoadingStates}
                  />
                </div>
              </div>
              <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                <div className="relative mt-[18px] w-full sm:w-11/12">
                  <Dropdown
                    control={control}
                    rightIcon={Icons.arrowIcon}
                    label={"City"}
                    options={cities}
                    selectedValue={select?.city}
                    handleSelect={(value) =>
                      handleDropdwonSelect("city", value)
                    }
                    valueName="city"
                    valueoption="city_id"
                    name={"city"}
                    errors={errors}
                    isRequired={true}
                    isLoading={citiesisLoading}
                  />
                </div>
                <div className="relative mt-[18px] w-full sm:w-11/12">
                  <Dropdown
                    control={control}
                    rightIcon={Icons.arrowIcon}
                    label={"Gender"}
                    options={dropdowns?.gender}
                    name={"gender"}
                    selectedValue={select.gender}
                    handleSelect={(value) =>
                      handleDropdwonSelect("gender", value)
                    }
                    valueName="gender"
                    valueoption="id"
                    isRequired={true}
                    isLoading={dropdownLoading}
                  />
                </div>
              </div>
              <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                <div className="relative mt-[18px] w-full">
                  <label className="block text-base font-medium text-secondary mb-8">
                    Age
                  </label>

                  <div className="relative h-5" ref={sliderRefAge}>
                    {tooltipPosAge.map(
                      (pos, i) =>
                        rangeAge[i] > 0 && (
                          <div
                            key={i}
                            className="absolute -top-7 transform -translate-x-1/2 text-white text-xs font-semibold px-2 py-1 rounded whitespace-nowrap bg-goldMetallic"
                            style={{ left: `${pos}%` }}
                          >
                            {rangeAge[i]} years
                            <div className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-goldMetallic" />
                          </div>
                        )
                    )}
                  </div>

                  <RangeSlider
                    id="range-slider-height"
                    min={6}
                    max={90}
                    step={1}
                    value={rangeAge}
                    onInput={handleInputAge}
                    className="yellow-slider"
                  />

                  <style jsx>{`
                    .yellow-slider .range-slider__thumb {
                      background-color: #d4af37; /* goldMetallic */
                    }
                    .yellow-slider .range-slider__range {
                      background-color: #d4af37;
                    }
                  `}</style>
                </div>
              </div>
              <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                <div className="relative mt-[18px] w-full">
                  <Dropdown
                    control={control}
                    rightIcon={Icons.arrowIcon}
                    label={"Ethnicity"}
                    options={dropdowns?.ethnicity}
                    name={"ethnicity"}
                    selectedValue={select.ethinicity}
                    handleSelect={(value) =>
                      handleDropdwonSelect("ethinicity", value)
                    }
                    valueName="name"
                    valueoption="ethnicity_id"
                    errors={errors}
                    isRequired={true}
                    isLoading={isLoading}
                  />
                </div>
              </div>
              <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                <div className="relative mt-[18px] w-full sm:w-11/12">
                  <Dropdown
                    control={control}
                    rightIcon={Icons.arrowIcon}
                    label={"Hair Types"}
                    options={dropdowns?.hairTypes}
                    name={"hairTypes"}
                    selectedValue={select.hairTypes}
                    valueName="name"
                    valueoption="hair_type_id"
                    handleSelect={(value) =>
                      handleDropdwonSelect("hairTypes", value)
                    }
                    errors={errors}
                    isRequired={true}
                    isLoading={isLoading}
                  />
                </div>
                <div className="relative mt-[18px] w-full sm:w-11/12">
                  <Dropdown
                    control={control}
                    rightIcon={Icons.arrowIcon}
                    label={"Eye Colors"}
                    options={dropdowns?.eyeColors}
                    name={"eyeColors"}
                    selectedValue={select.eyeColors}
                    valueName="name"
                    valueoption="eye_color_id"
                    handleSelect={(value) =>
                      handleDropdwonSelect("eyeColors", value)
                    }
                    errors={errors}
                    isRequired={true}
                    isLoading={isLoading}
                  />
                </div>
              </div>
              <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                <div className="relative mt-[18px] w-full">
                  <label className="block text-base font-medium text-secondary mb-8">
                    Height
                  </label>
                  <div className="relative h-5" ref={sliderRefHeight}>
                    {tooltipPosHeight.map((pos, i) => (
                      <div
                        key={i}
                        className="absolute -top-7 transform -translate-x-1/2 text-white text-xs font-semibold px-2 py-1 rounded whitespace-nowrap bg-goldMetallic"
                        style={{ left: `${pos}%` }}
                      >
                        {rangeHeight[i]} cm
                        <div className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-goldMetallic" />
                      </div>
                    ))}
                  </div>

                  <RangeSlider
                    id="range-slider-height"
                    min={120}
                    max={220}
                    step={1}
                    value={rangeHeight}
                    onInput={handleInputHeight}
                    className="yellow-slider"
                  />

                  <style jsx>{`
                    .yellow-slider .range-slider__thumb {
                      background-color: #d4af37; /* goldMetallic */
                    }
                    .yellow-slider .range-slider__range {
                      background-color: #d4af37;
                    }
                  `}</style>
                </div>
              </div>
              <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}>
                <div className="relative mt-[18px] w-full">
                  <div className="w-full text-white">
                    <label className="block xs:text-sm sm:text-base font-onestRegular text-secondary mb-8">
                      Weight
                    </label>
                    <div className="relative">
                      <div className="relative h-5" ref={sliderRefWeight}>
                        {tooltipPosWeight.map((pos, i) => (
                          <div
                            key={i}
                            className="absolute -top-7 transform -translate-x-1/2 text-white text-xs font-semibold px-2 py-1 rounded whitespace-nowrap bg-goldMetallic"
                            style={{ left: `${pos}%` }}
                          >
                            {rangeWeight[i]} kg
                            <div className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-goldMetallic" />
                          </div>
                        ))}
                      </div>

                      <RangeSlider
                        id="range-slider-yellow"
                        min={25}
                        max={200}
                        step={1}
                        value={rangeWeight}
                        onInput={handleInputWeight}
                        className="yellow-slider"
                      />
                      <style jsx>{`
                        .yellow-slider .range-slider__thumb {
                          background-color: #d4af37; /* goldMetallic */
                        }
                        .yellow-slider .range-slider__range {
                          background-color: #d4af37;
                        }
                      `}</style>
                    </div>
                  </div>
                </div>
              </div>
              <div className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4 pt-2"}>
                <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-2">
                  <CheckBoxSelection
                    control={control}
                    name="bodyTattoos"
                    mapitems={RadioValueandLable}
                    register={register}
                    errors={errors}
                    isRequired={false}
                    label="Body Modifications / Tattoos"
                  />
                </div>

                <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-1">
                  <CheckBoxSelection
                    control={control}
                    name="bodyPiercings"
                    mapitems={RadioValueandLable}
                    register={register}
                    errors={errors}
                    isRequired={false}
                    label="Body Modifications / Piercings"
                  />
                </div>
              </div>
              <div className="w-full">
                <Dropdown
                  control={control}
                  rightIcon={Icons.arrowIcon}
                  label={"Experience level"}
                  options={dropdowns?.experience}
                  valueName="job_experience"
                  valueoption="job_experience_id"
                  name={"experience"}
                  selectedValue={select.experienceLevel}
                  handleSelect={(value) =>
                    handleDropdwonSelect("experienceLevel", value)
                  }
                  errors={errors}
                  isRequired={true}
                  isLoading={isLoading}
                />
              </div>
            </div>
          </div>

          {/* Footer Buttons */}
          <div className="py-2 w-full">
            <div className="flex justify-end">
              <Text
                text="Reset Filters"
                align="text-right hover:text-secondary transition-colors duration-300 ease-in-out"
                className={"mt-2 mb-3 cursor-pointer w-fit"}
                color="text-orangeCrayola"
                size={fontSizes.h14}
                onClick={resetFilters}
                weight={TextWeight.Onest_regular}
              />
            </div>
            <Button
              text="Apply"
              type={"submit"}
              bgColor="bg-accepted"
              color="text-secondary"
              className="w-full rounded-full"
              textSize={fontSizes.h16}
              weight={TextWeight.Onest_regular}
              loading={isLoading}
              isDisabled={isLoading}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Talent;